<template>
  <div class="phairify-insights">
    <div class="mt-3">
      <v-wait :for="`${$options.name}_loading`">
        <template slot="waiting">
          <HalfCircleSpinner />
          <div class="spinner-message my-3 text-center">
            Load insights data...
          </div>
        </template>
        <template>
          <div v-for="q in results" :key="q.title">
            <h2
              class="v2_font_size_24 v2_font_weight_semibold v2_color_primary_teal"
            >
              {{ q.title }}
            </h2>
            <b-row
              v-if="q.results && q.results.length"
              class="survey-results__results-chart mt-5"
            >
              <b-col
                md="6"
                class="mb-4"
                sm="12"
                v-for="res in q.results"
                :key="res.id"
              >
                <div class="mx-auto h-100 shadow-none phairify-chart-card">
                  <div v-if="res && res.chart_title">
                    <h2
                      class="v2_font-Source v2_font_size_18 v2_color_black mb-0"
                    >
                      <span>{{ res.chart_title }}</span>
                    </h2>
                  </div>
                  <b-card-body>
                    <div v-if="res && res.results && !res.results.length">
                      <b-alert show variant="warning">
                        No results found
                      </b-alert>
                    </div>
                    <div v-else-if="res && res.insufficient">
                      <b-alert show variant="warning">
                        There is not enough data to display
                      </b-alert>
                    </div>
                    <div v-else-if="res">
                      <ChartBuilder
                        :comparison="{}"
                        :format="'dashboard'"
                        :result="res"
                      />
                    </div>
                  </b-card-body>
                </div>
              </b-col>
            </b-row>

            <b-row v-else align-h="center">
              <b-col class="text-center">
                <p
                  class="phairify-insights-warn my-4 phairify-color-darken_red"
                >
                  {{ 'No insights are available for this study.' }}
                </p>
              </b-col>
            </b-row>
          </div>
        </template>
      </v-wait>
    </div>
  </div>
</template>

<script>
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';
import ChartBuilder from '@/components/survey/results/ChartBuilder';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

export default {
  name: 'MssAdminInsights',
  components: {
    HalfCircleSpinner,
    ChartBuilder,
  },
  data: function () {
    return {
      results: {},
    };
  },
  created: function () {
    this.getResults();
  },
  methods: {
    getResults: async function () {
      this.results = [];
      this.$wait.start(`${this.$options.name}_loading`);

      try {
        this.results = await Api.mssAdminGetQuestionResultsForDashboard();
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(`${this.$options.name}_loading`);
      }
    },
  },
};
</script>

<style lang="scss" />
